import React from "react";
import styled from "styled-components/macro";
import {
  Label,
  OptionalLabel,
  TextArea,
} from "../../../styles/StyledComponents";
import Asterix from "../../../assets/asterix.svg";
import { useTranslation } from "react-i18next";

interface InputFieldProps {
  type: string;
  id: string;
  label: string;
  placeholder: any;
  fieldKey: string;
  required: boolean;
  value: any;
  onChange: Function;
  error: any;
  asterixFirst?: boolean;
  secondaryLabel?: string;
  rows?: number;
  disabled?: boolean;
  maxLength?: number;
  className?: string;
}
const Image = styled.img`
  width: 8px;
  height: 8px;
`;

const ErrorLabel = styled.span`
  fontsize: 11px;
  color: red;
`;
function TextAreaField({
  type,
  id,
  label,
  placeholder,
  fieldKey,
  required,
  value,
  onChange,
  error,
  asterixFirst,
  secondaryLabel,
  disabled,
  rows,
  maxLength,
  className,
}: InputFieldProps) {
  const { t } = useTranslation();
  return (
    <>
      <Label htmlFor={id}>
        {asterixFirst && required ? (
          <Image src={Asterix} className="mr-1" />
        ) : (
          ""
        )}
        {t(label)} <OptionalLabel>{secondaryLabel}</OptionalLabel>
        {required && !asterixFirst ? <Image src={Asterix} /> : ""}
      </Label>
      <TextArea
        id={id}
        placeholder={t(placeholder) || ""}
        rows={rows ? rows : 3}
        disabled={disabled}
        wrap="hard"
        required={required}
        value={value}
        onChange={(e: any) => {
          onChange(e.target.value);
        }}
        maxLength={maxLength ? maxLength : undefined}
        className={className}
      />
      <ErrorLabel>{error ? error : ""}</ErrorLabel>
    </>
  );
}

export default TextAreaField;
